/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useCallback } from 'react';

import { jsx } from '@atlaskit/css';
import { ComposableEditor } from '@atlaskit/editor-core/composable-editor';

import { serializeEditorDocument } from '../../fields/editor/serialize-editor-document';
import type { useEditorPreset } from '../../fields/editor/useEditorPreset';

type EditorPreset = ReturnType<typeof useEditorPreset>;

export const RichTextEditor = ({
	value,
	preset,
	editorApi,
	shouldFocus,
	onChange,
	disabled = false,
}: {
	value: string;
	preset: EditorPreset['preset'];
	editorApi?: EditorPreset['editorApi'];
	shouldFocus?: boolean;
	onChange?: (value: string) => void;
	disabled?: boolean;
}): JSX.Element => {
	const handleChange = useCallback(() => {
		editorApi?.core.actions.requestDocument((doc) => {
			onChange?.(serializeEditorDocument(doc));
		});
	}, [editorApi, onChange]);

	return (
		<ComposableEditor
			key={value}
			shouldFocus={shouldFocus}
			disabled={disabled}
			preset={preset}
			maxHeight={160}
			appearance="chromeless"
			onChange={onChange ? handleChange : undefined}
			onEditorReady={(actions) => {
				if (value) {
					actions.replaceDocument(value);
				}
			}}
		/>
	);
};
